import { useLazyQuery, useQuery } from '@apollo/client'
import { useEffect, useState } from 'react'

export function useLazySwrQuery(query, options) {
  const [fetch, { loading, client, variables, ...rest }] = useLazyQuery(
    query,
    options
  )
  const [localLoading, setLocalLoading] = useState(true)

  useEffect(() => {
    if (loading) {
      try {
        const d = client.readQuery({
          query,
          variables,
        })
        if (d) {
          setLocalLoading(false)
        }
        // eslint-disable-next-line no-empty
      } catch (e) {}
    } else {
      setLocalLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  return [fetch, { loading: localLoading, client, variables, ...rest }]
}

export function useSwrQuery(query, options) {
  const { loading, client, variables, ...rest } = useQuery(query, options)
  const [localLoading, setLocalLoading] = useState(true)

  useEffect(() => {
    if (loading) {
      try {
        const d = client.readQuery({
          query,
          variables,
        })
        if (d) {
          setLocalLoading(false)
        }
        // eslint-disable-next-line no-empty
      } catch (e) {}
    } else {
      setLocalLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  return { loading: localLoading, client, variables, ...rest }
}
